import { Link, useRouterState } from '@tanstack/react-router'
import { cn } from '@akillidernek/ui'

const SEKMELER = [
  { to: '/ayarlar/dernek', label: 'Dernek' },
  { to: '/ayarlar', label: 'Sağlayıcılar' },
  { to: '/ayarlar/menu', label: 'Menü' },
  { to: '/ayarlar/roller', label: 'Roller' },
  { to: '/ayarlar/kullanicilar', label: 'Kullanıcılar' },
  { to: '/ayarlar/ozel-alanlar', label: 'Özel Alanlar' },
  { to: '/ayarlar/alan-adlari', label: 'Alan Adları' },
  { to: '/ayarlar/abonelik', label: 'Abonelik' },
] as const

/** Ayarlar bölümünün alt gezinmesi. Menüde tek "Ayarlar" öğesi var; bölüm
 *  içindeki dallanma buradan yürüyor. */
export function AyarlarSekmeleri() {
  const path = useRouterState({ select: (state) => state.location.pathname })

  return (
    <div className="flex gap-1 rounded-[var(--radius-control)] bg-[var(--ad-surface-muted)] p-1">
      {SEKMELER.map((sekme) => (
        <Link
          key={sekme.to}
          to={sekme.to}
          className={cn(
            'rounded-[var(--radius-control)] px-3 py-1.5 text-sm',
            path === sekme.to
              ? 'bg-[var(--ad-surface)] font-medium shadow-sm'
              : 'text-[var(--ad-text-muted)]',
          )}
        >
          {sekme.label}
        </Link>
      ))}
    </div>
  )
}
